// extracted by mini-css-extract-plugin
export default {"root":"YJzfCVNUiDTaVEZ7Lk_b"};